module.exports = __webpack_public_path__ + "img/u5.0b825d7c.png";